import React from 'react';
import { COMPARE_PRICE, LAUNCH_ACTIVE, MOCKUP_URL, NEXT_PRICE, PRICE, PRODUCT_NAME } from '../data/config';
import { purchaseAssurances } from '../data/kit';
import { CTAButton, Section, Tag } from './Shared';
export function FinalOffer() {
  return <Section id="oferta-final" tone="cream" data-id="element-67" data-mp="1ghqcr68pbauf">
      <div className="grid items-center gap-8 lg:grid-cols-2 lg:gap-14" data-id="element-68" data-mp="1ceafc7ot56go">
        <img src={MOCKUP_URL} alt="Kit Disfraces de Halloween completo: 2 tomos y 5 bonus" loading="lazy" className="mx-auto h-auto w-full max-w-[480px] drop-shadow-xl" draggable={false} data-id="element-69" data-mp="1ch6bprl0bn30" />

        <div className="text-center lg:text-left" data-id="element-70" data-mp="1ldnsbac54d65">
          <Tag variant="white" data-id="element-71" data-mp="203cun8vyyn80">🎃 TODO EL KIT EN UNA SOLA COMPRA</Tag>
          <h2 className="mt-4 text-[32px] font-extrabold leading-[1.1] text-brand-violet md:text-5xl" data-id="element-72" data-mp="1v5jsqs1p8fdj">{PRODUCT_NAME}</h2>
          <p className="mt-2 text-xl font-bold text-brand-orangeDark" data-id="element-73" data-mp="294b4i7t39oyi">2 tomos + 5 bonus</p>
          <p className="mt-2 text-base font-medium text-brand-ink/80" data-id="element-74" data-mp="246huf3oo0asy">7 PDFs · 140 páginas · 16 propuestas de disfraces</p>

          <div className="mt-6 flex items-baseline justify-center gap-4 lg:justify-start" data-id="element-75" data-mp="1qqnek2wc5es">
            <span className="text-xl font-bold text-brand-ink/55 line-through" data-id="element-76" data-mp="6pl49ghazjw9">{COMPARE_PRICE}</span>
            <span className="font-display text-5xl font-extrabold text-brand-violet md:text-6xl" data-id="element-77" data-mp="bmlem3l6r8t6">
              {PRICE}
              <span className="ml-1 text-xl md:text-2xl" data-id="element-78" data-mp="go0xbozw538e">ARS</span>
            </span>
          </div>

          {LAUNCH_ACTIVE && <p className="mt-3 text-sm font-bold text-brand-violet" data-id="element-79" data-mp="pne76irxfttn">
              ⏰ Precio de lanzamiento hasta el domingo 25/10 · Después aumenta a {NEXT_PRICE}
            </p>}
          <CTAButton className="mt-5" data-id="element-80" data-mp="uggtq6yae30c">QUIERO CREAR ESTE HALLOWEEN EN FAMILIA →</CTAButton>
          <p className="mt-3 text-sm font-medium text-brand-ink/75" data-id="element-81" data-mp="zfa59tu0jjxv">Pago único · Formato PDF · Materiales no incluidos</p>
          <ul className="mt-4 flex flex-wrap justify-center gap-2 lg:justify-start" data-id="element-82" data-mp="18dvozsb81508">
            {purchaseAssurances.map(item => <li key={item} className="rounded-full bg-white px-3 py-1.5 text-sm font-bold text-brand-violet shadow-card" data-id="element-83" data-mp="35e02lipbbkmx">
                {item}
              </li>)}
          </ul>

          <p className="mt-8 rounded-2xl bg-white p-5 text-left text-base leading-relaxed text-brand-ink shadow-card" data-id="element-84" data-mp="3e6la22nhu4wg">
            <strong className="text-brand-violet" data-id="element-85" data-mp="39fv52qizc42a">P.D.:</strong> Podés empezar por el personaje que más les guste. No
            hace falta realizar todos los proyectos para disfrutar el kit.
          </p>
        </div>
      </div>
    </Section>;
}